export const categories = [
  {
    slug: 'yingshi',
    name: '影视精选',
    description: '精选全球热门影视作品，涵盖电影、剧集、短片等多元类型',
    icon: 'ri-movie-2-line',
    count: 128,
  },
  {
    slug: 'jiaoyu',
    name: '教育学习',
    description: '优质教育视频资源，助力终身学习与个人成长',
    icon: 'ri-book-open-line',
    count: 96,
  },
  {
    slug: 'yule',
    name: '娱乐综艺',
    description: '轻松有趣的娱乐内容，让闲暇时光充满欢乐',
    icon: 'ri-emotion-happy-line',
    count: 85,
  },
  {
    slug: 'jilupian',
    name: '纪录片',
    description: '探索世界奥秘，记录真实故事，拓展认知边界',
    icon: 'ri-earth-line',
    count: 64,
  },
  {
    slug: 'keji',
    name: '科技前沿',
    description: '最新科技动态、产品评测与数码生活指南',
    icon: 'ri-cpu-line',
    count: 72,
  },
  {
    slug: 'shenghuo',
    name: '生活方式',
    description: '美食、旅行、家居、健身等品质生活视频内容',
    icon: 'ri-heart-line',
    count: 58,
  },
  {
    slug: 'yinyue',
    name: '音乐艺术',
    description: '音乐演出、艺术展览与创意文化视频集锦',
    icon: 'ri-music-line',
    count: 47,
  },
  {
    slug: 'donghua',
    name: '动漫天地',
    description: '热门动漫、二次元文化与动画短片精选',
    icon: 'ri-ghost-line',
    count: 93,
  },
];

export const getCategoryBySlug = (slug: string) => {
  return categories.find((c) => c.slug === slug) || categories[0];
};